<template>
  <ReportTable v-bind="$attrs"
               :custom-formatted-columns="customFormattedColumns"
               looping-key="invoice_id"
               :enable-dropdown="enableDropdown"
               :dropdown-options="dropdownOptions"
               @dropdownChanged="dropdownChanged($event)">
    <template v-if="enableLinks" v-slot:cell(link)="data">
      <div class="data-table-body-row-link-wrapper">
        <a v-if="linksDomain"
           :href="`${linksDomain}/invoices/${data.data.item.invoice_hash_token}`"
           class="data-table-body-row-link-wrapper-icon">
          <i class="demo-icon icon-chevron-right icon-chevron-right" />
        </a>
        <router-link v-else
                     :to="{ path: `/invoices/${data.data.item.invoice_hash_token}` }"
                     class="data-table-body-row-link-wrapper-icon">
          <i class="demo-icon icon-chevron-right icon-chevron-right" />
        </router-link>
      </div>
    </template>

    <template v-if="enableLinks" v-slot:cell(invoice_subject)="data">
      <div class="column-text-wrapper">
        <a v-if="linksDomain" :href="`${linksDomain}/invoices/${data.data.item.invoice_hash_token}`">
          {{ data.data.value }}
        </a>
        <router-link v-else :to="{ path: `/invoices/${data.data.item.invoice_hash_token}` }">
          {{ data.data.value }}
        </router-link>
      </div>
    </template>

    <template v-slot:cell(invoice_customer_name)="data">
      <div class="column-text-wrapper">
        <a v-if="linksDomain" :href="`${linksDomain}/customers/${data.data.item.invoice_customer_id}`">
          {{ data.data.value }}
        </a>
        <router-link v-else :to="{ path: `/customers/${data.data.item.invoice_customer_id}` }">
          {{ data.data.value }}
        </router-link>
      </div>
    </template>

    <template v-slot:cell(invoice_status)="data">
      <span :class="statusCellClass(data.data.item)">
        {{ data.data.value | capitalize }}
      </span>
    </template>
  </ReportTable>
</template>

<script>
import ReportTable from "@shared/components/UI/Report/Table.vue";

export default {
  name: "InvoiceReportTable",

  components: {
    ReportTable
  },

  props: {
    enableLinks: { type: Boolean, default: true },
    enableDropdown: { type: Boolean, default: false },
    dropdownOptions: { type: Array },
    linksDomain: { type: String, default: "" }
  },

  data () {
    return {
      customFormattedColumns: ["invoice_subject", "invoice_status", "invoice_customer_name"]
    };
  },

  methods: {
    statusCellClass (item) {
      let badges = {
        paid: "success",
        outstanding: "secondary",
        refunded: "info",
        refundable: "info",
        cancelled: "warning",
        expired: "danger",
        void: "warning",
        overdue: "danger",
        draft: "grey"
      };

      return `status-indicator badge-${badges[item.invoice_status]}`;
    },

    dropdownChanged (e) {
      this.$emit("dropdownChanged", e);
    }
  }
};
</script>
